export default __webpack_public_path__ + "static/media/logo-voda.eaf97708.png";